import styled from 'styled-components';

import { Button as DefaultButton } from '@xing-com/button';
import * as layoutTokens from '@xing-com/layout-tokens';
import * as tokens from '@xing-com/tokens';

export const Button = styled(DefaultButton)`
  margin-right: ${tokens.spaceS};

  @media ${layoutTokens.mediaWide} {
    margin-left: ${tokens.spaceS};
    margin-right: 0;
  }

  .isArmstrong {
    display: none;

    @media ${layoutTokens.mediaWide} {
      display: flex;
    }
  }
`;
